import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Row, Col, Form, FormGroup, Button,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import NewEntityButton from './NewEntityButton';
import { InputField } from '../blocks/edit_blocks';
import { TableScreenWithoutUpdate } from '../blocks/table_block';
import Fetcher from '../common/communicate';
import { PROJECT_PREFIX } from '../const';

const API_ENDPOINT = 'authors/?';

export default class AuthorsScreen extends React.Component {
    constructor(props) {
        super(props);
        this.filterChange = this.filterChange.bind(this);
        this.filterCleanup = this.filterCleanup.bind(this);
        this.refreshState = this.refreshState.bind(this);
        this.removeItemHandler = this.removeItemHandler.bind(this);
        this.state = {
            filter: {},
            results: [],
            previous: 'none',
            next: 'none',
            total_pages: 0,
            current_page: 1,
        };
        this.API_ENDPOINT_QS = '';
    }

    refreshState() {
        this.setState({ results: [] });
    }

    removeItemHandler(event) {
        if (window.confirm(`Внимание! Вы действительно хотите удалить ${event.currentTarget.dataset.name || ''}?`)) {
            Fetcher(`${API_ENDPOINT.replace('?', '') + event.currentTarget.id}/`, 'DELETE', this.refreshState);
        }
    }

    columns = [{
        Header: 'E-mail',
        accessor: 'email',
        Cell: (row) => (
            <div>
                <Link to={`${PROJECT_PREFIX}/authors/${row.value}/edit`}>
                    {row.value}
                </Link>
            </div>
        ),
    }, {
        Header: 'Ник',
        accessor: 'nick',
    }, {
        Header: 'Like Hammer',
        accessor: 'like_hammer',
        Cell: (row) => (
            row.value ? <FontAwesomeIcon icon="check" />
                : <FontAwesomeIcon icon="minus" />
        ),
    }, {
        Header: 'Ревьювер?',
        accessor: 'is_reviewer',
        Cell: (row) => (
            row.value ? <FontAwesomeIcon icon="check" />
                : <FontAwesomeIcon icon="minus" />
        ),
    }, {
        Header: '',
        accessor: 'email',
        maxWidth: 40,
        Cell: (row) => (
            <Button size="sm" variant="link" id={row.value} data-name={row.original.nick} onClick={this.removeItemHandler}>
                <FontAwesomeIcon id={row.value} icon="trash" />
            </Button>
        ),
    },

    ];

    filterChange(event) {
        const filter_params = this.state.filter;
        const key = event.currentTarget.id;
        let { value } = event.currentTarget;

        if (event.currentTarget.type === 'checkbox') {
            value = event.currentTarget.checked;
        }

        filter_params[key] = value;
        this.setState({ filter: filter_params });

        let result_qs = '';

        for (let i = 0; i < Object.keys(filter_params).length; i++) {
            const key = Object.keys(filter_params)[i];
            result_qs += `&${key}=${filter_params[key]}`;
        }

        this.API_ENDPOINT_QS = result_qs;
    }

    filterCleanup() {
        this.API_ENDPOINT_QS = '';
        this.setState({ filter: {} });
    }

    render() {
        return (
            <div className="container-fluid">
                <Row className="mb-2">
                    <Col md={12}>
                        <NewEntityButton to="/authors/new" />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Form inline>
                            <FormGroup>
                                <InputField
                                    value={this.state.filter.search || ''}
                                    label="Фильтр"
                                    name="search"
                                    onChange={this.filterChange}
                                    placeholder="Email или ник"
                                />
                                {' '}
                                <Button variant="outline-secondary" onClick={this.filterCleanup}>
                                    Сбросить
                                </Button>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
                <TableScreenWithoutUpdate
                    columns={this.columns}
                    endpoint={API_ENDPOINT + this.API_ENDPOINT_QS}
                    data={this.state}
                />
            </div>

        );
    }
}
